// N(4) Bundle Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Michelle", location: "TX", product: "N(4) 1 Bottle", time: "12 minutes ago" },
    { name: "Alejandro", location: "CA", product: "N(4) 1 Bottle", time: "26 minutes ago" },
    { name: "Yamini", location: "CA", product: "N(4) 1 Bottle", time: "41 minutes ago" },
    { name: "Devin", location: "CA", product: "N(4) 1 Bottle", time: "57 minutes ago" },
    { name: "Julius", location: "IN", product: "N(4) 1 Bottle", time: "1 hour 14 minutes ago" },
    { name: "Gerard", location: "CA", product: "N(4) 1 Bottle", time: "1 hour 32 minutes ago" },
    { name: "Estefania", location: "CA", product: "N(4) 1 Bottle", time: "1 hour 51 minutes ago" },
    { name: "Cruz", location: "TX", product: "N(4) 1 Bottle", time: "2 hours 11 minutes ago" },
    { name: "Mike", location: "MA", product: "N(4) 1 Bottle", time: "2 hours 32 minutes ago" },
    { name: "Gladys", location: "FL", product: "N(4) 1 Bottle", time: "2 hours 54 minutes ago" },
    { name: "Andrea", location: "FL", product: "N(4) 1 Bottle", time: "13 minutes ago" },
    { name: "Bil", location: "CA", product: "N(4) 1 Bottle", time: "28 minutes ago" },
    { name: "Nicole", location: "CA", product: "N(4) 1 Bottle", time: "43 minutes ago" },
    { name: "Lacy", location: "APO", product: "N(4) 1 Bottle", time: "58 minutes ago" },
    { name: "Garrett", location: "LA", product: "N(4) 1 Bottle", time: "1 hour 15 minutes ago" },
    { name: "Sean", location: "CA", product: "N(4) 1 Bottle", time: "1 hour 33 minutes ago" },
    { name: "Thomas", location: "CA", product: "N(4) 1 Bottle", time: "1 hour 52 minutes ago" },
    { name: "Nick", location: "IN", product: "N(4) 1 Bottle", time: "2 hours 12 minutes ago" },
    { name: "Mileidy", location: "TX", product: "N(4) 1 Bottle", time: "2 hours 33 minutes ago" },
    { name: "Israel", location: "CA", product: "N(4) 3 Bottles", time: "14 minutes ago" },
    { name: "Nathaniel", location: "TX", product: "N(4) 1 Bottle", time: "29 minutes ago" },
    { name: "Tina", location: "OH", product: "N(4) 1 Bottle", time: "45 minutes ago" },
    { name: "Nick", location: "CA", product: "N(4) 3 Bottles", time: "1 hour 1 minute ago" },
    { name: "Jose", location: "CA", product: "N(4) 1 Bottle", time: "1 hour 18 minutes ago" },
    { name: "Eli", location: "GA", product: "N(4) 3 Bottles", time: "1 hour 36 minutes ago" },
    { name: "Jerry", location: "CA", product: "N(4) 1 Bottle", time: "1 hour 55 minutes ago" },
    { name: "Jonathan", location: "CA", product: "N(4) 12 Bottles", time: "2 hours 15 minutes ago" },
    { name: "Michelle", location: "TX", product: "N(4) 1 Bottle", time: "2 hours 36 minutes ago" },
    { name: "Ulises", location: "FL", product: "N(4) 1 Bottle", time: "2 hours 58 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/N4_Omega_Zoom.png?v=1733532242" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
